// extracted by mini-css-extract-plugin
export default {"followBtnBelow":"_2zrvx","followBtnInLine":"_1j93S","friendsCountBelow":"_1wsDG","friendsCountInLine":"_3Lewu","text":"_19Lu2","number":"_2djmW"};